window.VideoPlayer = class {
  constructor(rootElement, url, title) {
    this.rootElementID = rootElement;
    this.root = document.querySelector(rootElement);
    this.url = url;
    this.title = title;
    this.initVideoPlayer();
  }

  initVideoPlayer() {
    if (!this.root) {
      console.error("Fixed CTA root element not found.");
      return;
    }

    const playButton = this.root.querySelector(".nri-video-play-button");
    const videoElement = this.root.querySelector(".nri-video");

    if (!playButton || !videoElement) {
      console.error("Fixed CTA elements not found.");
      return;
    }

    playButton.addEventListener("click", () => {
      videoElement.innerHTML = `
        <iframe id="nri-video-player-iframe-${this.rootElementID}" title="${this.title}" src="${this.url}" frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen=""></iframe>
      `;
      videoElement.classList.add("video-active");
    });

  }
  
};
